<template>
  <div v-if="userProfile">
    <vx-card no-shadow>
      <div class="vx-row mb-6 mt-2">
        <div class="vx-col sm:w-2/5 w-full">
          <h4>Personal information</h4>
        </div>
      </div>

      <div class="vx-row mb-6" v-if="userProfile.profileImageUrl">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Image</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-avatar size="large" style="object-fit: cover" :src="userProfile.profileImageUrl" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Venue</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-row class="align-bottom">
            <code>{{ userProfile.venueName }}</code>
          </vs-row>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Name</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-row class="align-bottom">
            <vs-input label="First name" class="mr-2" v-model="userProfile.firstName" />
            <vs-input label="Last name" class="mr-2" v-model="userProfile.lastName" />
          </vs-row>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Email</span>
        </div>
        <div class="vx-col sm:w-3/5 w-full">
          <vs-input type="email" disabled="true" class="w-full" :warning="!validateEmail(userProfile.email)"
            warning-text="E-mail not valid" v-model="userProfile.email" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Phone number</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-row>
            <vs-input type="phone" v-model="userProfile.phoneCountryCode" style="max-width: 64px" class="mr-2"
              disabled="true" />
            <vs-input type="phone" v-model="userProfile.phoneNumber" disabled="true" />
          </vs-row>
          <!-- <vs-input
            type="phone"
            :warning="!validatePhone(profile.phone)"
            warning-text="Phone not valid"
            v-model="profile.phone"
          /> -->
        </div>
      </div>

      <!--<div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Gender</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-select width="100px" v-model="profile.gender">
            <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in genders" />
          </vs-select>
        </div>
      </div>-->

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Birthdate</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <v-date-picker v-model="userProfile.birthDate" mode="date" class="max-w-full"
            :modelConfig="{ type: 'string', mask: 'YYYY-MM-DD' }"
            :attributes="[{ highlight: { fillMode: 'light' }, dates: new Date() }]">
            <template v-slot="{ inputValue, inputEvents }">
              <vs-input :value="inputValue" v-on="inputEvents" class="max-w-full mr-0" />
            </template>
          </v-date-picker>
          <!-- <DatePicker mode="dateTime" :attributes="calendarAttributes" is-expanded v-model="userProfile.birthDate" /> -->
        </div>
      </div>

      <div class="vx-row mb-6" v-if="hasPermission('vp.crm.guestprofiles.extended.view')">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Address</span>
        </div>
        <div class="vx-col sm:w-3/5 w-full">
          <vs-row>
            <vs-input label="Street 1" class="mr-2" v-model="userProfile.street1" />
            <vs-input label="Street 2" class="mr-2" v-model="userProfile.street2" />
            <vs-input label="Zip code" class="mr-2" v-model="userProfile.zip" />
            <vs-input label="City" class="mr-2" v-model="userProfile.city" />
          </vs-row>
        </div>
      </div>

      <div class="vx-row mb-6" v-if="hasPermission('vp.crm.guestprofiles.extended.view')">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Country</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <code>{{ userProfile.guestCountry }}</code>
          <!-- <vs-select width="300px" v-model="userProfile.country" :disabled="true">
            <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in countries" />
          </vs-select> -->
        </div>
      </div>

      <div class="vx-row mb-6" v-if="userProfile.referralAction">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Referred by</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <span>
            <code>
        <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
        {{ userProfile.referralAction.userDisplayName }}
      </code>
          </span>
        </div>
      </div>

      <div class="vx-row mb-6" v-if="userProfile.socials">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Socials</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <p v-if="userProfile.socials.facebook">
            <feather-icon icon="FacebookIcon" svgClasses="w-4 h-4" />
            {{ userProfile.socials.facebook }}
          </p>
          <p v-if="userProfile.socials.instagram">
            <feather-icon icon="InstagramIcon" svgClasses="w-4 h-4" />
            {{ userProfile.socials.instagram }}
          </p>
        </div>
      </div>

      <vs-divider />
      <div class="vx-col lg:w-1/1 w-full">
        <h5 class="mb-6">Nightpay</h5>
      </div>

      <div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Connected to Nightpay</span>
          </div>
          <div class="vx-col sm:w-4/5 w-full">
            <vs-chip>{{ (userProfile.nightpayUserId != null && userProfile.nightpayUserId != "") | yesno }}</vs-chip>
          </div>
        </div>
        <div class="vx-row mb-6" v-if="userProfile.nightpayUserId">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Nightpay user id</span>
          </div>
          <div class="vx-col sm:w-4/5 w-full">
            <code>{{ userProfile.nightpayUserId }}</code>
          </div>
        </div>
      </div>

      <vs-divider />
      <div class="vx-col lg:w-1/1 w-full">
        <h5 class="mb-6">Activity</h5>
      </div>

      <div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Last activity</span>
          </div>
          <div class="vx-col sm:w-4/5 w-full">
            <div class="flex flex-col gap-2">
              <div>
                <code>{{ userProfile.lastActive | formatDate }} (Last active {{ format(userProfile.lastActive) }})</code>
              </div>
              <div>
                <vs-chip color="danger" v-if="lastActiveSoonAnonmize">Will be automatically anonymized soon</vs-chip>
              </div>
            </div>
          </div>
        </div>
      </div>

      <vs-divider />
      <div class="vx-col lg:w-1/1 w-full">
        <h5 class="mb-6">Venue permissions</h5>
      </div>

      <div :key="idx" v-for="(permission, idx) in userProfile.consentedPermissions">
        <div class="flex items-center gap-2 mt-1">
          <vs-chip>
            {{ getPermissionWithId(permission).title }}&nbsp;<small>({{ permission }})</small>
          </vs-chip>
        </div>
      </div>

      <div v-if="hasPermission('vp.crm.guestprofiles.extended.view')">
        <vs-divider />

        <div class="vx-col lg:w-1/1 w-full">
          <h5 class="mb-6">Segmentation points</h5>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Labels</span>
          </div>
          <div class="vx-col sm:w-4/5 w-full">
            <vs-chip :key="idx" v-for="(tag, idx) in userProfile.labels">
              {{ tag.value }}
            </vs-chip>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Interests</span>
          </div>
          <div class="vx-col sm:w-4/5 w-full">
            <vs-col class="interest-card mr-5" v-for="(tag, idx) in userProfile.interests" :key="idx">
              <div>
                <vx-card>
                  <div class="card-header">
                    <vs-row vs-justify="center" class="mb-3">
                      <feather-icon :icon="getInterestIcon(tag.key)" svgClasses="h-5 w-5" />
                    </vs-row>
                    <vs-row vs-justify="center">
                      <strong>
                        {{ tag.key }}
                      </strong>
                    </vs-row>
                  </div>
                  <vs-row vs-justify="center">
                    {{ tag.value }}
                  </vs-row>
                </vx-card>
                <!-- <vs-chip :key="idx" v-for="(tag, idx) in profile.interests">
            {{ tag.key }}: <strong>{{ tag.value }}</strong>
          </vs-chip> -->
              </div>
            </vs-col>
          </div>
        </div>
      </div>

      <vs-divider />
      <!-- Save & Remove Button -->
      <vs-row vs-justify="space-between" class="flex flex-wrap items-center" style="margin-top: 32px">
        <vs-button id="remove-button" @click="confirmRemove" color="danger" class="mt-2"
          v-if="hasPermission('vp.crm.guestprofiles.edit')">Anonymize guest</vs-button>
        <vs-button id="save-button" :disabled="!validateEmail(userProfile.email) && !validatePhone(userProfile.phone)"
          v-if="hasPermission('vp.crm.guestprofiles.edit')" @click="update" class="mt-2">Save Changes</vs-button>
      </vs-row>
    </vx-card>

    <vx-card no-shadow> </vx-card>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import moment from "moment";
import validators from "@/views/mixins/validators";
import { format } from "timeago.js";

export default {
  mixins: [validators],
  props: {
    userProfile: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      moment,
      format,
      genders: ["Male", "Female", "Other", "NoSpecify", "NotSet"],
      countries: ["DK", "NO", "FI", "UK"]
      // touchpointSources: ["Unknown", "Web", "SMS", "Email", "Form", "Booking", "Nightpay", "App", "Nyx", "ComplianceForm", "LightBooth"]
    };
  },
  methods: {
    async update() {
      this.$vs.loading();

      try {
        console.log("Updating profile", this.userProfile);
        await this.$store.dispatch("userProfiles/updateUserProfile", {
          country: this.activeCountryId,
          userId: this.userProfile.id,
          dto: {
            firstName: this.userProfile.firstName,
            lastName: this.userProfile.lastName,
            phone: this.userProfile.phone,
            birthDate: this.userProfile.birthDate,
            street1: this.userProfile.street1,
            street2: this.userProfile.street2,
            zip: this.userProfile.zip,
            city: this.userProfile.city
          }
        });

        this.$vs.notify({
          color: "green",
          title: "Saved",
          text: "Saved"
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Could not be saved",
          text: "Could not be saved"
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async confirmRemove() {
      console.log(this.userProfile.interests);
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to anonymize this guest? This action cannot be reverted",
        accept: this.remove
      });
    },
    async remove() {
      this.$vs.loading();
      try {
        await this.$store.dispatch("userProfiles/anonymize", { country: this.activeCountryId, userId: this.userProfile.id });
        this.$vs.notify({
          color: "green",
          title: "User anonymized",
          text: "Successfully anonymized user"
        });

        // Reload
        window.location.reload();
      } catch {
        this.$vs.notify({
          color: "danger",
          title: "Could not anonymize",
          text: "User most likely already anonymized"
        });
      }
      this.$vs.loading.close();
    },
    getInterestIcon(iconName) {
      const interest = this.interests.find(e => e.name === iconName);
      return interest ? interest.icon : "";
    },
    getPermissionWithId(id) {
      var persmission = this.guestPermissions.find(e => e.id === id);
      return persmission ? persmission : { title: "Unknown" };
    }
  },
  computed: {
    ...mapGetters({
      interests: "guestSegmentation/interests",
      guestPermissions: "legalDocuments/guestPermissions",
      activeCountryId: "venues/activeCountryId"
    }),
    lastActiveSoonAnonmize() {
      if (!this.userProfile.lastActive) {
        return false;
      }
      // If last active is more than 2 years ago (minus 14 days), we should warn about anonymizing
      return moment().subtract(2, "years").add(14, "days").isAfter(this.userProfile.lastActive);
    },
    phone() {
      return `${this.userProfile.phoneCountryCode} ${this.userProfile.phone}`;
    }
  }
};
</script>

<style lang="scss">
.interest-card {
  min-width: 160px;
  max-width: 160px;

  .vx-card {
    border-top: 4px #ccc solid;
  }
}

.vuexy-design {
  color: inherit;
  position: relative;
  padding: 0.4rem;
  border-radius: 5px;
  padding: 0.7rem !important;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 0 0 0 0 rgb(0 0 0 / 15%);
  box-shadow: 0 0 0 0 rgb(0 0 0 / 15%);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  width: 100%;
}

.vs-avatar--con-img img {
  object-fit: cover;
}
</style>

<style lang="scss" scoped></style>